import { Flex } from 'portal-commons';
import { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from '@/shared_elements';
import BrandAssetsBackButton from '../components/BrandAssetsBackButton';
import BrandAssetsEmulatorBlock from '../components/BrandAssetsEmulatorBlock';
import { BrandAssetExtended, BrandAssetType } from '../types';
import { getBrandAssets } from '../apis';
import { useSoleProprietorCheck } from '../hooks/useSoleProprietorCheck';

const BrandAssetsEmulator: FunctionComponent = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [logos, setLogos] = useState<BrandAssetExtended[]>([]);
  const [banners, setBanners] = useState<BrandAssetExtended[]>([]);

  const { isLoading } = useSoleProprietorCheck(id);

  const fetchBrandAssets = async () => {
    setLoading(true);
    const data = await getBrandAssets(id);
    if (data) {
      setLogos(data.filter((item) => item.type === BrandAssetType.Logo));
      setBanners(data.filter((item) => item.type === BrandAssetType.Banner));
    }
    setLoading(false);
  };

  const updateAssetFile = (
    assets: BrandAssetExtended[],
    index: number,
    file: File
  ): BrandAssetExtended[] => {
    return assets.map((item, i) => (i === index ? { ...item, file } : item));
  };

  const handleAssetUpdate = (
    type: BrandAssetType,
    index: number,
    file: File
  ) => {
    if (type === BrandAssetType.Logo) {
      setLogos((prev) => updateAssetFile(prev, index, file));
    } else if (type === BrandAssetType.Banner) {
      setBanners((prev) => updateAssetFile(prev, index, file));
    }
  };

  useEffect(() => {
    fetchBrandAssets();
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Flex sx={{ flexDirection: 'column', gap: 17 }}>
      <BrandAssetsBackButton link={`/brands/${id}`} />
      <BrandAssetsEmulatorBlock
        brandId={id}
        logos={logos}
        banners={banners}
        isLoading={loading}
        onAssetUpdate={handleAssetUpdate}
        onAssetVerified={fetchBrandAssets}
      />
    </Flex>
  );
};

export default BrandAssetsEmulator;
